"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinesSchema = exports.OnOffStates = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.OnOffStates = (0, yup_1.mixed)().oneOf(['on', 'off']);
exports.LinesSchema = model_schema_1.Schema.shape({
    lineStatus: exports.OnOffStates.default('off'),
    lineOffMessage: (0, yup_1.string)().notRequired(),
    lineOffReason: (0, yup_1.string)().notRequired(),
    customMessage: (0, yup_1.string)().notRequired(),
    customMessageStatus: exports.OnOffStates.default('off'),
    facia: (0, yup_1.string)().notRequired(),
    lineType: (0, yup_1.string)().required(),
    botEnabled: (0, yup_1.boolean)().default(false),
    faciaDisplay: (0, yup_1.string)(),
    greetingMessageARN: (0, yup_1.string)()
        .nullable()
        .default(null),
    group: (0, yup_1.string)().required(),
    orderLookupEnabled: (0, yup_1.boolean)().default(false),
    queueLimit: (0, yup_1.number)().required(),
    hidePlugins: (0, yup_1.array)((0, yup_1.string)()).default([]),
    showPlugins: (0, yup_1.array)((0, yup_1.string)()).default([]),
    languageCodes: (0, yup_1.array)((0, yup_1.string)()).default([]),
    company: (0, yup_1.string)().required(),
    callRecording: (0, yup_1.mixed)()
        .oneOf(['NONE', 'AGENT_AND_CUSTOMER', 'AGENT_ONLY', 'CUSTOMER_ONLY'])
        .default('NONE'),
    rejectIfLineLimitFails: (0, yup_1.boolean)().notRequired(),
    businessContinuityLabel: (0, yup_1.string)().required(),
});
